/**
 * @class
 * @function SwipeScroller
 */
if (!customElements.get("swipe-scroller")) {
  class SwipeScroller extends HTMLElement {
    constructor() {
      super();
      this.inner = null;
      this.btnPrev = null;
      this.btnNext = null;
      this.resizeObserver = null;
      this.onPrevClick = this.onPrev.bind(this);
      this.onNextClick = this.onNext.bind(this);
      this.onInnerScroll = this.onScroll.bind(this);
      this.onViewportResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.inner = this.querySelector("[data-swipe-inner]");

      if (!this.inner) return;

      this.btnPrev = this.querySelector("[data-swipe-prev]");
      this.btnNext = this.querySelector("[data-swipe-next]");

      if (!this.btnPrev || !this.btnNext) return;

      this.btnPrev.type = "button";
      this.btnNext.type = "button";

      this.btnPrev.addEventListener("click", this.onPrevClick);
      this.btnNext.addEventListener("click", this.onNextClick);
      this.inner.addEventListener("scroll", this.onInnerScroll, {
        passive: true,
      });

      if ("ResizeObserver" in window) {
        this.resizeObserver = new ResizeObserver(this.onViewportResize);
        this.resizeObserver.observe(this.inner);
      } else {
        window.addEventListener("resize", this.onViewportResize, {
          passive: true,
        });
      }

      this.updateState();
    }

    disconnectedCallback() {
      this.btnPrev?.removeEventListener("click", this.onPrevClick);
      this.btnNext?.removeEventListener("click", this.onNextClick);
      this.inner?.removeEventListener("scroll", this.onInnerScroll);
      window.removeEventListener("resize", this.onViewportResize);
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
    }

    getScrollAmount() {
      const card = this.inner.querySelector("[data-swipe-card]");
      const gap = parseFloat(getComputedStyle(this.inner).columnGap) || 0;
      return card ? card.offsetWidth + gap : this.inner.clientWidth;
    }

    onPrev() {
      if (!this.inner) return;
      this.inner.scrollBy({ left: -this.getScrollAmount(), behavior: "smooth" });
    }

    onNext() {
      if (!this.inner) return;
      this.inner.scrollBy({ left: this.getScrollAmount(), behavior: "smooth" });
    }

    onScroll() {
      window.requestAnimationFrame(() => this.updateState());
    }

    onResize() {
      if (!this.inner) return;
      this.updateState();
    }

    updateState() {
      if (!this.inner) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.inner;
      const isScrollable = scrollWidth > clientWidth + 1;
      const isAtStart = scrollLeft <= 0;
      const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      this.classList.toggle("is-scrollable", isScrollable);
      this.btnPrev.hidden = !isScrollable;
      this.btnNext.hidden = !isScrollable;
      this.btnPrev.disabled = !isScrollable || isAtStart;
      this.btnNext.disabled = !isScrollable || isAtEnd;

      this.classList.toggle("is-at-start", isAtStart);
      this.classList.toggle("is-at-end", isAtEnd);
    }
  }

  customElements.define("swipe-scroller", SwipeScroller);
}
